import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { FC } from 'react';
import {
  FormBackground,
  FormSubmitButton,
} from 'src/pages/VerificationPage/components/VerificationPageActions/VerificationReportForm/index.styled';
import { toast } from 'react-toastify';
import { toastOptions } from 'src/common/components/Toast/config';
import { SuccessToast } from 'src/pages/VerificationPage/components/VerificationPageActions/VerificationReportForm/SuccessToast';
import { verificationIdParam } from 'src/routes';
import { useSendVerificationReportMutation } from 'src/pages/VerificationPage/verificationQueries';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormInput } from 'src/common/components/Input/FormInput';
import { SecondaryButton } from 'src/common/components/Button';

export const verificationReportSchema = z
  .object({
    email: z.string().email(),
    emailRepeat: z.string().email(),
  })
  .refine(({ email, emailRepeat }) => email === emailRepeat, {
    path: ['emailRepeat'],
    message: 'Wartości w obu polach muszą być zgodne',
  });

type VerificationReportFormModel = z.infer<typeof verificationReportSchema>;

interface VerificationReportFormProps {
  onModalClose: () => void;
}

export const VerificationReportForm: FC<VerificationReportFormProps> = ({
  onModalClose,
}) => {
  const verificationId = localStorage.getItem(verificationIdParam);
  const { mutate, isLoading } = useSendVerificationReportMutation();

  const methods = useForm<VerificationReportFormModel>({
    mode: 'all',
    resolver: zodResolver(verificationReportSchema),
  });

  const onSubmit: SubmitHandler<VerificationReportFormModel> = (
    data,
    event
  ) => {
    event?.preventDefault();
    verificationId &&
      mutate(
        { verificationId, email: data.email.trim() },
        {
          onSuccess: () => {
            toast(<SuccessToast />, toastOptions);
            methods.reset();
            onModalClose();
          },
        }
      );
  };

  return (
    <FormBackground>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormInput name="email" placeholder="E-mail" />
          <FormInput name="emailRepeat" placeholder="Powtórz adres e-mail" />
          <FormSubmitButton
            type="submit"
            disabled={!methods.formState.isValid || isLoading}
          >
            Wyślij raport
          </FormSubmitButton>
          <SecondaryButton onClick={onModalClose}>Anuluj</SecondaryButton>
        </form>
      </FormProvider>
    </FormBackground>
  );
};
